<template>
    <v-card width="auto" tile>
        <v-form ref="form">
          <v-card-text>

            <v-row dense v-if="steps == 0">
                <v-col cols="12">
                    <v-text-field
                        v-model="model.nombre"
                        label="Nombre"
                        outlined
                        :rules="fieldRequired"
                        dense>
                    </v-text-field>
                </v-col>
            </v-row>

            <p class="text--center title pa-1"> Agregar Preguntas</p>
            <v-row dense v-if="steps == 1">
              <v-col cols="12">
                  <v-text-field
                      v-model="pregunta.pregunta"
                      label="Pregunta"
                      :rules="fieldRequired"
                      outlined
                      dense>
                  </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="pregunta.respuesta.field"
                  label="Tipo Pregunta"
                  :rules="fieldRequired"
                  :items="itemTypes"
                  outlined
                  dense>
                </v-select>
              </v-col>
              <v-col cols="8" v-if="pregunta.respuesta.field == 'radioButton' || pregunta.respuesta.field == 'checkbox'">
                <v-row dense>
                  <v-col cols="10">
                    <v-text-field
                        v-model="item"
                        label="Respuestas"
                        outlined
                        dense>
                    </v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <v-btn class="mx-2" fab dark small color="warning" @click="saveItems">
                      <v-icon dark>
                        mdi-plus
                      </v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="12">
                    <v-chip
                      v-for="(item, index) in pregunta.respuesta.items" :key="index"
                      class="ma-1"
                      close
                      color="orange"
                      label
                      outlined
                      @click:close="removeItem(index)">
                      {{ item }}
                    </v-chip>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-layout>
                  <v-btn class="amber lighten-1" dark @click="addQuestion">Agregar</v-btn>
                </v-layout>
              </v-col>
              <v-col cols="12">
                <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
              </v-col>

            </v-row>
          </v-card-text>

          <v-card-actions>
              <v-layout justify-end>
                <v-btn class="red darken-1 mr-3" dark @click="onCancel">Cancelar</v-btn>
                <v-btn class="green darken-1 mr-3" dark @click="save"> {{buttonName}}</v-btn>
              </v-layout>
          </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import { Validate } from '@/mixins/validateFormMixin'
import DataTableMain from '@/components/tables/DataTableMain'
export default {
  props: ['model', 'onSuccess', 'onCancel'],
  mixins: [Validate],
  data: () => ({
    buttonName: 'Crear Encuesta',
    steps: 0,
    pregunta: {
      pregunta: '',
      respuesta: {
        field: '',
        items: []
      },
      encuesta_id: 1
    },
    item: '',
    itemTypes: ['text', 'textArea', 'radioButton', 'checkbox'],
    table: {
      header: {
        options: [],
        titles: [
          { text: 'Pregunta', value: 'pregunta', class: 'black--text' },
          { text: 'Tipo Pregunta', value: 'respuesta.field', class: 'black--text' },
          { text: '', value: 'Actions', class: 'black--text' }
        ],
        loading: false
      },
      body: {
        data: [],
        actions: [
          { title: 'Eliminar', icon: 'mdi-delete', color: 'red darken-3', action: 'toDeleteItem' }
        ]
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain
  },
  methods: {
    successAction (item) {
      this[item.action](item)
    },
    tableAction (item) {
      this[item.action](item)
    },
    toDeleteItem (item) {
      this.model.preguntas = this.model.preguntas.filter(el => el.index !== item.item.index)
      this.table.body.data = this.model.preguntas
    },
    /* *==========* *==========* *==========* *==========* *==========* */
    save () {
      if (this.steps === 0) {
        if (this.$refs.form.validate()) {
          this.buttonName = 'Guardar'
          this.table.body.data = this.model.preguntas
          this.steps = 1
        } else {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'ERROR',
            text: 'Debe agregar un nombre a la encuesta'
          })
        }
      } else if (this.steps === 1) {
        if (this.model.preguntas.length > 0) {
          this.onSuccess(this.model)
        } else {
          this.$swal({
            type: 'error',
            icon: 'error',
            title: 'ERROR',
            text: 'Debe agregar preguntas a la encuesta'
          })
        }
      }
    },
    addQuestion () {
      if (this.$refs.form.validate()) {
        this.pregunta.index = (this.model.preguntas.length + 1)
        this.model.preguntas.push(this.pregunta)
        this.table.body.data = this.model.preguntas
        this.pregunta = {
          pregunta: '',
          respuesta: {
            field: '',
            items: []
          }
        }
      } else {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'ERROR',
          text: 'Hay campos obligatorios'
        })
      }
    },
    saveItems () {
      if (this.item !== '') {
        this.pregunta.respuesta.items.push(this.item)
        this.item = ''
      }
    },
    removeItem (index) {
      console.log('index', index)
      this.pregunta.respuesta.items = this.pregunta.respuesta.items.filter((el, i) => i !== index)
    }
  },
  computed: {
    ...mapGetters(['get_dialogMain'])
  }
}
</script>

<style>

</style>
